import { useState } from 'react';
import Header from './components/Header';
import HeroCarousel from './components/HeroCarousel';
import Footer from './components/Footer';
import ContactModal from './components/ContactModal';
import './styles.css';

export default function App() {
  const [contactOpen, setContactOpen] = useState(false);

  const handleContactSubmit = (data) => {
    console.log('CONTACT FORM DATA:', data);
    // Next step: fetch('/api/contact', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(data) })
  };

  return (
    <div className="app">
      <Header onContactClick={() => setContactOpen(true)} />
      <main className="main">
        <HeroCarousel />
      </main>
      <Footer />
      <ContactModal
        open={contactOpen}
        onClose={() => setContactOpen(false)}
        onSubmit={(data) => console.log('CONTACT OK', data)}
        // {handleContactSubmit} {((d)=>{})}
      />
    </div>
  );
}
